import React from "react"
import { Row, Col } from 'antd';
import './style.scss'
const arrs = [
    {name:"Dawn Song",con:"University of California, Berkeley",img:"https://img.alicdn.com/imgextra/i1/O1CN01JtH3MJ1LuSuRCPtuN_!!6000000001359-2-tps-300-300.png",link:"https://people.eecs.berkeley.edu/~dawnsong/"},
    {name:'Yisen Wang',con:'Peking University',img:'https://i1.rgstatic.net/ii/profile.image/827313545555969-1574258328672_Q512/Yisen-Wang-5.jpg',link:'https://sites.google.com/site/csyisenwang/'},
    {name:'Zico Kolter',con:'CMU',img:'https://img.alicdn.com/imgextra/i1/O1CN014bdoES1ZAZqXoTi2C_!!6000000003154-2-tps-300-300.png', link:'https://zicokolter.com'},
    {name:'Ce Zhang',con:'ETH Zurich',img:'https://media-exp1.licdn.com/dms/image/C4D03AQFYSO-DSsxWnw/profile-displayphoto-shrink_800_800/0/1516807494652?e=1629331200&v=beta&t=zLiMYgOj8sPxKC8wTrVcg69eDcpv_JMn4i-6v4e5vUY',link:'https://ds3lab.inf.ethz.ch/members/ce-zhang.html'},
    {name:'Lujo Bauer',con:'CMU',img:'https://img.alicdn.com/imgextra/i4/O1CN01y5dB7s1uVHgVCbbSf_!!6000000006042-2-tps-300-300.png',link:'https://www.ece.cmu.edu/directory/bios/bauer-lujo.html'},
    {name:'Nicolas Papernot',con:'University of Toronto',img:'https://img.alicdn.com/imgextra/i1/O1CN01am87Cm1zzZxaEaqIT_!!6000000006785-2-tps-300-300.png',link:'https://www.papernot.fr'},
    {name:'Ding Zhao',con:'CMU',img:'https://img.alicdn.com/imgextra/i2/O1CN01wYRlGA1cUg4ldvCS6_!!6000000003604-2-tps-300-300.png',link:'https://safeai-lab.github.io'},
    // {name:'Trevor Darrell',con:'UC Berkeley',img:'https://img.alicdn.com/imgextra/i2/O1CN01cwBgn41zJtv7BCwnA_!!6000000006694-2-tps-300-300.png', link:'https://people.eecs.berkeley.edu/~trevor'},
    {name:'Una-May O’Reilly',con:'MIT',img:'https://img.alicdn.com/imgextra/i2/O1CN01rWBxNj1yVWLma45Nh_!!6000000006584-2-tps-300-300.png',link:'https://www.csail.mit.edu/person/una-may-oreill'},
]
export default function Invited() {
    return <div className="page-invited">
            <div className="invited-title">Invited Speakers</div>
            <Row className="list-ul">
                {arrs.map((item, index) => (<Col xl={6} md={12} span={24} key={index} className="list-li"> 
                    <div className="list-two" onClick={() => { window.open(item.link) }}>
                        <img src={item.img}  alt=""/>
                        <div className="pro-div">
                            <span>{item.name}</span>
                            <b/>
                            <div  dangerouslySetInnerHTML = {{__html : item.con}} />
                        </div>
                        
                    </div>
                </Col>))}
            </Row>
        </div>
}
